import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function ChevronDown({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <ChevronDown.Outline {...props} />
  ) : (
    <ChevronDown.Solid {...props} />
  );
}

ChevronDown.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

ChevronDown.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M5.84399 8.62524L12.594 15.3752L19.344 8.62524"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
